/**
 * Jul-2026 (User-Wunsch) — Warnhinweis bei jeder VIN/FIN-Eingabe, solange die
 * 17 Stellen nicht vollständig erreicht sind (oder überschritten wurden).
 */
import { AlertTriangle } from "lucide-react";

export const VinWarning = ({ value, allowShortCode = false }) => {
    const v = String(value || "").replace(/[\s-]/g, "");
    if (!v || v.length === 17) return null;
    if (allowShortCode && v.length === 8) return null;
    return (
        <div className="mt-1 inline-flex items-center gap-1.5 text-[11px] font-bold text-amber-700" data-testid="vin-length-warning">
            <AlertTriangle className="w-3.5 h-3.5 shrink-0" />
            {v.length > 17
                ? `Fahrgestellnummer zu lang: ${v.length}/17 Zeichen`
                : `Fahrgestellnummer unvollständig: ${v.length}/17 Zeichen`}
        </div>
    );
};

export default VinWarning;
